import { put, takeLatest, select, all } from "redux-saga/effects";
import { appNotify, fetchInventoryData, setInventoryData, setIsLoading } from "../store/actions";
import { rentalInventorySelector, retailInventorySelector, dashboardChannelsSelector } from 'store/selectors';
import { postWithToken } from "../api/network";

export function* getDashboardInventoryDataSaga() {
  yield takeLatest(fetchInventoryData, function* ({payload}) {
    try {
      yield put(setIsLoading({inventoryType: payload.inventoryType, isLoading: true}));

      const inventorySelector = payload.inventoryType.toLowerCase() === 'rental'
        ? rentalInventorySelector
        : retailInventorySelector;

      const [props, channels] = yield all([
        select(inventorySelector),
        select(dashboardChannelsSelector)
      ]);
      
      let allStrategiesIncluded = props.allStrategiesIncluded === 'includeAll' ? true : false;
      const fromDate = new Date(Date.UTC(props.fromTime.getFullYear(), props.fromTime.getMonth(), props.fromTime.getDate(), props.fromTime.getHours(), props.fromTime.getMinutes(), props.fromTime.getSeconds()));
      const toDate = new Date(Date.UTC(props.toTime.getFullYear(), props.toTime.getMonth(), props.toTime.getDate(), props.toTime.getHours(), props.toTime.getMinutes(), props.toTime.getSeconds()));

      var data = {
        toDate: toDate,
        fromDate: fromDate,
        channels: channels,
        includeAllStrategies: allStrategiesIncluded,
        strategies: props.selectedStrategies,
      }
      
      let url = `/api/dashboard/getDashboardInventoryData`;
      const res = yield postWithToken(url, data);
      const inventoryData = yield res.json();

      console.log(`Inventory data: `, inventoryData);

      yield put(setInventoryData({inventoryData, inventoryType: payload.inventoryType}));
      yield put(setIsLoading({inventoryType: payload.inventoryType, isLoading: false}));
    } catch (error) {
      console.error(error);
      yield put(appNotify(`Failed to fetch rental inventory tasks: ${error.message}`, 'error'));
      yield put(setIsLoading({inventoryType: payload.inventoryType, isLoading: false}));
    }
  });
}
